import {acreInSF} from './constants';

export const buildRentScheduleRow = function(rentScheduleData) {
    return {
        valueCells: [{
            // Monthly
            editable: true,
            type: 'string',
            unit: '$',
            valueNeedsFormatting: true,
            withoutPlaceholder: true,
            value: rentScheduleData.MONTHLY_RENT || '',
        }, {
            // BLDG PSF/YR
            editable: false,
            type: 'number',
            unit: '$',
            tooltip: '= annual_rent / gross_leasable_area',
            getComputedValue(tables, i) {
                const index = parseInt(i);
                if (!tables['annualized-operating-data'].rows[index])
                    return {internalValue: null, displayValue: ''};

                const annualRent = tables['annualized-operating-data'].rows[index].valueCells[2].getComputedValue(tables, index).internalValue;
                const grossLeasableArea = tables['offering-summary'].rows['gross-leasable-area'].value;
                const value = parseFloat(annualRent / grossLeasableArea).toFixed(2);
                const displayValue  = value && !isNaN(value) ? `$${value.toLocaleString()}` : '-';
                return {internalValue: value, displayValue}
            },
        }, {
            // LAND PSF/YR
            editable: false,
            type: 'number',
            unit: '$',
            tooltip: '= annual_rent / (lot_size*43560)',
            getComputedValue(tables, i) {
                const index = parseInt(i);
                if (!tables['annualized-operating-data'].rows[index])
                    return {internalValue: null, displayValue: ''};

                const annualRent = tables['annualized-operating-data'].rows[index].valueCells[2].getComputedValue(tables, index).internalValue;
                const grossLeasableArea = parseFloat(tables['offering-summary'].rows['lot-size'].value);
                const value = parseFloat(annualRent / (grossLeasableArea * acreInSF)).toFixed(2);
                const displayValue  = value && !isNaN(value) ? `$${value.toLocaleString()}` : '-';
                return {internalValue: value, displayValue};
            },
        },]
    }
};

export default {
    name: 'RENT SCHEDULE',
    headerRow: ['Monthly', 'BLDG PSF/YR', 'LAND PSF/YR'],
    footerRow: {
        valueCells: [null, null, null]
    },
    rows: {},
};